export const docUploadAnalytics = {
    constants: {
        pageNameNoVehicle: 'fv:dynamic manage:doc upload',
        pageID: 'dynamic manage',
        contentSubType: 'doc upload',
        pTemplate: 'none',
        linkType: 'cta',
        clickAction: 'click',
        nameplate: window?.digitaldata?.vehicle?.nameplate || '',
        satelliteTrackId: 'ecommInternalCtaClick',
        errorSatelliteTrackId: 'moduleErrorCtaClick'
    },
    prepareDataLayer: function (value) {
        return {
            onclick: {
                onclickLinkName: `${this.constants.pageNameNoVehicle}:${this.constants.linkType}:${value}:${this.constants.nameplate}`,
                onclick: `${this.constants.pageID}:${this.constants.contentSubType}:${this.constants.linkType} ${this.constants.clickAction}:${value}`,
                contentType: `${this.constants.pageID}:${this.constants.pTemplate}:${this.constants.clickAction}`,
                contentSubType: `${this.constants.contentSubType}`
            }
        }
    },
    backToDM: function () {
        return this.prepareDataLayer('back to dynamic manage')
    },
    uploadDoc: function (documentName) {
        return this.prepareDataLayer(`${documentName}:upload`)
    },
    cancel: function (documentName) {
        return this.prepareDataLayer(`${documentName}:cancel edit`)
    },
    delete: function (documentName) {
        return this.prepareDataLayer(`${documentName}:delete doc`)
    },
    confirmDelete: function (documentName) {
        return this.prepareDataLayer(`${documentName}:delete doc confirm`)
    },
    edit: function (documentName) {
        return this.prepareDataLayer(`${documentName}:edit doc`)
    },
    done: function (documentName) {
        return this.prepareDataLayer(`${documentName}:done`)
    },
    error: function (errorMessage) {
        const dataLayer = this.prepareDataLayer('error states')
        return {
            ...dataLayer,
            user: {
                errorTracking: errorMessage
            }
        }
    },
    track: function (eventName, value = '') {
        value = value.toLowerCase()
        const updatedDataLayer = this[eventName](value)
        window.digitaldata = window.digitaldata || {}
        if (window?.digitaldata?.user?.errorTracking) {
            delete window.digitaldata.user.errorTracking
        }
        window.digitaldata = {
            ...window.digitaldata,
            ...updatedDataLayer
        }
        const satelliteTrackId = updatedDataLayer?.user?.errorTracking
            ? this.constants.errorSatelliteTrackId
            : this.constants.satelliteTrackId
        if (window?._satellite) {
            window._satellite.track(satelliteTrackId)
        }
    }
}
